import { useTranslation } from 'react-i18next';
import type { TFunction } from 'react-i18next';
import isTouchDevice from '../../../../utils/isTouchDevice';

/**
 * useHourField — decide la variante del selector de hora.
 *
 * En dispositivos táctiles los `DateSegment` de react-aria invocan el teclado en pantalla
 * (`contentEditable` + `inputMode="numeric"`), que tapa el popover del picker (TAN-10405). Ahí se
 * renderiza `NativeHourInput`: iOS/Android abren su rueda de hora, que nunca solapa el popover.
 */

type UseHourFieldReturn = {
  isTouchDevice: boolean;
  t: TFunction;
};

export default function useHourField(): UseHourFieldReturn {
  const { t } = useTranslation();

  return { isTouchDevice: isTouchDevice(), t };
}
